<template lang="pug">
  .gw-headline__langs.gw-headline__dropdown.gw-headline__item(
    :class="getDropdownLinkClass",
    v-click-outside="closeDropdown"
  )
    .gw-headline__dropdown-default(@click="toggleDropdown", :class="{'one-language' : !showLanguagesDropdown}")
      span.gw-lang-flag(:class="languageClass(current_language)")
      | {{ languageTitle(current_language) }}

    .gw-headline__dropdown-list(v-if="showLanguagesDropdown && is_dropdown_show")
      a.gw-headline__dropdown-item(
        v-for="(language, language_key) in languages",
        :href="getLink(language_key)"
        :key="language_key"
      )
        span.gw-lang-flag(:class="languageClass(language_key)")
        | {{ languageTitle(language_key) }}

</template>

<script>
import DropdownMixin from "./DropdownMixin";
import env from "../../../libs/tools/Environment";

export default {
  name: "MyGamesHeadlineLanguages",

  mixins: [DropdownMixin],

  props: {
    promoName: {
      type: String,
      required: false,
    },
    showFullLanguages: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      current_language: env.getLang(),
      languages: env.getSupportedLangs(),
    };
  },

  computed: {
    showLanguagesDropdown() {
      return this.languages && Object.keys(this.languages).length > 1;
    },
  },

  methods: {
    languageClass(language) {
      return `gw-lang-flag_${language}`;
    },

    languageTitle(language) {
      return this.showFullLanguages
        ? this.languages[language].full_name
        : this.languages[language].initial;
    },
    getLink(language) {
      let link = env.isPromoPage()
        ? "/promo/" + this.promoName + "/" + language + ".html"
        : location.origin + "/" + language + location.pathname.substr(3);

      if (location.search) {
        link += location.search;
      }
      if (location.hash) {
        link += location.hash;
      }
      return link;
    },
  },
};
</script>

<style lang="stylus">
.gw-headline__langs {
  text-transform: capitalize;
}

.gw-lang-flag {
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 22px;
  height: 16px;
  background-image: url('data:image/png;base64,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');
  background-position: 0 0;
  background-repeat: no-repeat;

  &_en {
    background-position: 0 0;
  }

  &_en_GB {
    background-position: -22px 0;
  }

  &_de {
    background-position: -44px 0;
  }

  &_fr {
    background-position: -66px 0;
  }

  &_ru {
    background-position: -88px 0;
  }

  &_it {
    background-position: -110px 0;
  }

  &_pl {
    background-position: -132px 0;
  }

  &_tr {
    background-position: -154px 0;
  }

  &_sp {
    background-position: -176px 0;
  }

  &_es {
    background-position: -176px 0;
  }

  &_zh {
    background-position: -198px 0;
  }

  &_zh_Hans {
    background-position: -198px 0;
  }
}

.gw-headline__dropdown-default.one-language {
  padding-right: 0;

  &:hover {
    cursor: default;
  }

  &::after {
    display: none;
  }
}
</style>
